const translations = {
    export: 'Export'
};

export default translations;
